import type { TComponent } from 'utils/types/component';

import type { TBalance } from 'models/Merchant/Balance';

import { MerchantCard } from '../MerchantCard';
import {
    CommonContent,
    DepositContent,
    PayoutsContent,
} from '../MerchantCardContent';
import styles from './MerchantCardList.module.scss';

interface IMerchantCardListProps {
    data: TBalance[];
}

export const MerchantCardList: TComponent<IMerchantCardListProps> = ({
    data,
}) => {
    const merchantsData = data.map((item) => ({
        currencyCode: item.currencyCode,
        id: item.merchantIdentity,
        name: item.merchantName,
        commonContent: <CommonContent item={item} />,
        depositsContent: <DepositContent item={item} />,
        payoutsContent: <PayoutsContent item={item} />,
    }));

    return (
        <div className={styles.list}>
            {merchantsData.map((merchant) => (
                <MerchantCard
                    key={`${merchant.id}-${merchant.currencyCode}`}
                    commonContent={merchant.commonContent}
                    depositsContent={merchant.depositsContent}
                    payoutsContent={merchant.payoutsContent}
                    currencyCode={merchant.currencyCode}
                />
            ))}
        </div>
    );
};
